export default "__VITE_ASSET__C453vzD$__"